import React, { useState } from 'react';
import EmailField from './common/EmailField';
import PasswordField from './common/PasswordField';

import { loginUser } from '../redux/actions/authActions';
import { connect } from 'react-redux';

function LoginPage({ history, loginUserAction, auth }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  function handleEmailChange(event) {
    setEmail(event.target.value)
  }
  function handlePasswordChange(event) {
    setPassword(event.target.value);
  }
  function handleLogin(event) {
    event.preventDefault();
    loginUserAction({ email, password }).then((response) => {
      console.log('handleLogin', response)
      history.push('/')
    });
  }

  return (
    <>
      <h1>Login</h1>

      <form onSubmit={handleLogin}>
        <div className='form-group'>
          <EmailField
            name='email'
            label='Email'
            value={email}
            placeholder='Email'
            onChange={handleEmailChange}
          />
        </div>

        <div className='form-group'>
          <PasswordField 
            name='password'
            label='Password'
            value={password}
            placeholder='Password'
            onChange={handlePasswordChange}
          />
        </div>

        <button type='submit' className='btn btn-primary' disabled={!email || !password}>
          Login
        </button>
      </form>

    </>
  );
}

const mapDispatchToProps = {
  loginUserAction: loginUser
};

function mapStateToProps({ auth }) {
  return {
    auth
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPage);
